// Reducer for homepage actions

import * as ActionTypes from '../constants/action_types'
import { DefaultState } from './DefaultState'
import * as ReducerUtils from './utils'

export const DefaultAttentionState = {
  details: { ...DefaultState },
  topAndTrending: { ...DefaultState }
}

export const topAndTrendingDetails = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultState,
  actionRequest: ActionTypes.REQUEST_ATTENTION_TOP_TRENDING,
  actionFailure: ActionTypes.REQUEST_ATTENTION_TOP_TRENDING_FAILURE,
  actionReceive: ActionTypes.RECEIVE_ATTENTION_TOP_TRENDING,
  actionInvalidate: ActionTypes.INVALIDATE_ATTENTION_TOP_TRENDING
})

export const anticipationDetails = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultState,
  actionRequest: ActionTypes.REQUEST_ATTENTION_INDEX,
  actionFailure: ActionTypes.REQUEST_ATTENTION_INDEX_FAILURE,
  actionReceive: ActionTypes.RECEIVE_ATTENTION_INDEX,
  actionInvalidate: ActionTypes.INVALIDATE_ATTENTION_INDEX
})

export const attentionIndex = (state = DefaultAttentionState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_ATTENTION_TOP_TRENDING:
    case ActionTypes.RECEIVE_ATTENTION_TOP_TRENDING:
    case ActionTypes.REQUEST_ATTENTION_TOP_TRENDING_FAILURE:
    case ActionTypes.INVALIDATE_ATTENTION_TOP_TRENDING:
      return {
        ...state,
        topAndTrending: topAndTrendingDetails(state.details, action)
      }
    case ActionTypes.REQUEST_ATTENTION_INDEX:
    case ActionTypes.RECEIVE_ATTENTION_INDEX:
    case ActionTypes.REQUEST_ATTENTION_INDEX_FAILURE:
    case ActionTypes.INVALIDATE_ATTENTION_INDEX:
      return {
        ...state,
        details: anticipationDetails(state.details, action)
      }
    default:
      return state
    }
}